<div class="p-3 pt-2 rounded-4">
  <div>
    <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
      <div class="p-3">Security Questions</div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4">
        <div class="alert alert-info">
          <strong>Security Tip:</strong> Set up security questions to add an extra layer of protection to your account.
          You need to select at least 2 questions (maximum 3).
        </div>

        <div class="card mb-3">
          <div class="card-header d-flex justify-content-between align-items-center">
            <span>Your Security Questions</span>
            <button class="btn btn-sm btn-primary" (click)="addQuestion()" [disabled]="selectedQuestions.length >= 3">
              <i class="bi bi-plus-circle"></i> Add Question
            </button>
          </div>
          <div class="card-body">
            @if (hasSecurityQuestions && selectedQuestions.length === 0) {
              <div class="text-center text-success py-4">
                <i class="bi bi-check-circle-fill fs-1"></i>
                <p class="mt-2">Security questions have already been configured.</p>
              </div>
            }
            @if (!hasSecurityQuestions && selectedQuestions.length === 0) {
              <div class="text-center text-muted py-4">
                <p>No security questions added yet.</p>
                <button class="btn btn-primary" (click)="addQuestion()">Add Your First Question</button>
              </div>
            }

            @for (q of selectedQuestions; track q; let i = $index) {
              <div class="mb-3 p-3 border rounded">
                <div class="row">
                  <div class="col-md-5">
                    <label class="form-label">Select Question {{ i + 1 }}</label>
                    <select class="form-select" [(ngModel)]="q.questionId" (change)="onQuestionChange(i)">
                      <option [value]="-1">-- Select a question --</option>
                      @for (question of availableQuestions; track question) {
                        <option [value]="question.id">
                          {{ question.question }}
                        </option>
                      }
                    </select>
                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Your Answer</label>
                    <input type="text" class="form-control" [(ngModel)]="q.answer"
                      placeholder="Enter your answer" maxlength="100">
                  </div>
                  <div class="col-md-2 d-flex align-items-end">
                    <button class="btn btn-danger btn-sm" (click)="removeQuestion(i)">
                      <i class="bi bi-trash"></i> Remove
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        @if (errorMessage) {
          <div class="alert alert-danger">{{ errorMessage }}</div>
        }
        @if (successMessage) {
          <div class="alert alert-success">{{ successMessage }}</div>
        }

        <div class="d-flex gap-2">
          <button class="btn btn-primary" (click)="saveSecurityQuestions()" [disabled]="isLoading || selectedQuestions.length === 0">
            @if (isLoading) {
              <span>Saving...</span>
            }
            @if (!isLoading) {
              <span>Save Security Questions</span>
            }
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
